import type { FormControl } from '@angular/forms';

import { isEmpty } from '@recruitee/utils';

import { URL_PATTERN } from '../regex-patterns';

export function urlValidator(control: FormControl<string | null>): { url: true } | null {
  return isEmpty(control.value) || URL_PATTERN.test(control.value) ? null : { url: true };
}
